interface WhatsAppButtonProps {
  label: string;
  phone: string;
  href: string;
}

export default function WhatsAppButton({ label, phone, href }: WhatsAppButtonProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${label}: ${phone}`}
      className="group inline-flex items-center gap-4 rounded-full border-2 border-accent-400/80 bg-background-900/70 pl-3 pr-7 py-3 cursor-pointer whitespace-nowrap transition-all duration-300 hover:border-accent-300 hover:bg-primary-900/60 hover:scale-[1.03] focus:outline-none focus-visible:ring-4 focus-visible:ring-accent-400/60 charvys-glow"
    >
      <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-[#25D366] text-white shrink-0">
        <i className="ri-whatsapp-line text-3xl md:text-4xl" />
      </span>
      <span className="flex flex-col items-start text-left">
        <span className="font-label text-[11px] md:text-sm font-semibold tracking-wider text-foreground-200">{label}</span>
        <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">{phone}</span>
      </span>
    </a>
  );
}